<template>
  <!--<div class="ui form" >-->
    <!--<div class="field">-->
      <!--<label v-if="!options.hideLabel">{{label}}</label>-->
      <div style="display:flex">
         <input ref="min" type="number" @input="onInputMin" :value="getValue[0]"
                 :placeholder="placeholder"
                 :readonly="propertyMin.readonly"
                 :min="propertyMin.minimum"
                 :max="getValue[1]"
                 style="flex:1 1 auto; margin-right: 8px"
          >
         <input ref="max" type="number" @input="onInputMax" :value="getValue[1]"
                 :placeholder="placeholder"
                 :readonly="propertyMax.readonly "
                 :min="getValue[0]"
                 :max="propertyMax.maximum"
                 style="flex:1 1 auto;"
          >
     </div>
    <!--</div>-->
  <!--</div>-->
</template>

<script>
  import minMaxControlMixin from './minMaxControlMixin'
  export default {
    name: "min-max-input-control",
    mixins: [ minMaxControlMixin],

    methods:{
      onInputMin($event) {this.setValue([$event.target.value,this.$refs.max.value])},
      onInputMax($event) {this.setValue([this.$refs.min.value,$event.target.value])}
    }
  }
</script>

<style>

</style>
